// components
import CommonActionModal from "../Common/CommonActionModal";
import TasksTab from "../Task/TasksTab";

// icons
import AssignmentIcon from "@mui/icons-material/Assignment";


class LaborReportTaskModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AssignmentIcon,
            buttonLabel: this.props.label,
            buttonColor: 'primary',
            modalLabel: 'Задачи',
            modalIcon: AssignmentIcon,
            mainComponent: TasksTab,
            mainComponentProps: {
                executor: this.props.executor,
                noPhase: this.props.noPhase,
                noOpportunity: this.props.noOpportunity,
            },
            ready: true,
        })
    }
}

export default LaborReportTaskModal